import React, { useState } from 'react';
import { 
    List, 
    Datagrid, 
    TextField, 
    DateField, 
    EmailField,
    NumberField,
    Button,
    useNotify,
    useRefresh,
    TopToolbar,
    ExportButton,
    SearchInput,
    useRecordContext
} from 'react-admin';
import SendIcon from '@mui/icons-material/Send';
import CircularProgress from '@mui/material/CircularProgress';

const ResendButton = () => {
    const record = useRecordContext();
    const notify = useNotify();
    const refresh = useRefresh();
    const [loading, setLoading] = useState(false);

    if (!record) return null;

    const handleResend = async (e: React.MouseEvent) => {
        e.stopPropagation();
        setLoading(true);
        try {
            const token = localStorage.getItem("auth");
            const response = await fetch(`${process.env.REACT_APP_API_URL}/failedEmails/${record.id}/resend`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
            });
            if (response.ok) {
                notify('Correo re-enviado con éxito', { type: 'success' });
                refresh();
            } else {
                const errorText = await response.text();
                // Mostrar en una alerta el motivo exacto de la falla
                alert(`Error al re-enviar el correo:\n\n${errorText}`);
                notify(`Fallo en el re-envío: ${errorText}`, { type: 'warning' });
                refresh();
            }
        } catch (error: any) {
            alert(`Error de red o servidor al re-enviar: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Button
            label="Re-enviar"
            onClick={handleResend}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={16} /> : <SendIcon />}
        />
    );
};

const ListActions = () => (
    <TopToolbar>
        <ExportButton />
    </TopToolbar>
);

const failedEmailFilters = [
    <SearchInput source="q" alwaysOn />,
];

const FailedEmailsList = () => {
    return (
        <List
            sort={{ field: 'createdAt', order: 'DESC' }}
            perPage={25}
            filters={failedEmailFilters}
            actions={<ListActions />}
            title="Correos Fallidos de SACOP"
        >
            <Datagrid bulkActionButtons={false}>
                <NumberField source="sacopId" label="ID SACOP" />
                <EmailField source="recipient" label="Destinatario" />
                <TextField source="subject" label="Asunto" />
                <TextField source="errorMessage" label="Detalle de Error" />
                <NumberField source="attempts" label="Intentos" />
                <TextField source="status" label="Estado" />
                <DateField source="createdAt" label="Fecha Fallo" showTime />
                <ResendButton />
            </Datagrid>
        </List>
    );
};

export default FailedEmailsList;
